import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  fullWidth: {
    padding: '40px 40px 0 40px',
    maxWidth: '100% !important'
  },
  boxMainContainer: {
    paddingBottom: '40px',
    overflowY: 'scroll'
  }
});
export default useStyles;